import React, { useEffect, useRef, useState } from "react";
import {
  Image,
  MessageContainer,
  MessageDescription,
  MessageTitle,
  ModalCloseButton,
  ModalContainer,
  ModalContent,
  ModalFooter,
  TextInput,
} from "../index.styled";
import { Loader } from "../../../App";
import { Title } from "../../Popup/index.styled";
import { StyledButton } from "../../AdvanceFilterComp/index.styled";
import CheckSuccessImg from "../../../Assets/Images/CheckSuccess.png";
import { ReactComponent as CrossSolid } from "../../../Assets/Icons/CrossSolid.svg";
import { viewSizeCalculator } from "../../../utils";

const SaveSearchModal = ({
  isOpen,
  onClose,
  handleAddItem,
  editItem,
  setIsOpenSaveModal,
  setIsSaveSearchChecked,
}) => {
  const [searchTitle, setSearchTitle] = useState(editItem?.title || "");
  const [isSaveBtnEnabled, setSaveBtnEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchSavedSuccess, setIsSearchSavedSuccess] = useState(false);

  const isAutoClosingRef = useRef(false);

  const handleSearchTitle = (e) => {
    const value = e.target.value;
    setSearchTitle(value);
    setSaveBtnEnabled(!!value.trim());
  };

  const handleSearchSaved = () => {
    if (editItem) {
      handleAddItem(searchTitle, editItem.id);
    } else {
      handleAddItem(searchTitle);
    }
    setIsSearchSavedSuccess(true);

    isAutoClosingRef.current = true;
    setTimeout(() => {
      if (isAutoClosingRef.current) {
        onClose();
        isAutoClosingRef.current = false;
      }
    }, 3000);
  };

  const handleClose = () => {
    isAutoClosingRef.current = false;
    setSearchTitle("");
    setIsOpenSaveModal(false);
    setIsSaveSearchChecked(false);
  };

  const handleCloseWithFilters = () => {
    isAutoClosingRef.current = false;
    setSearchTitle("");
    setSaveBtnEnabled(false);
    setIsSearchSavedSuccess(false);
    onClose();
  };

  useEffect(() => {
    if (editItem) {
      setSearchTitle(editItem.title);
      setSaveBtnEnabled(true);
    } else {
      setSearchTitle("");
      setSaveBtnEnabled(false);
    }
  }, [editItem, isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <ModalContainer>
      {isSearchSavedSuccess ? (
        <ModalContent width={28}>
          <ModalCloseButton>
            <CrossSolid onClick={handleCloseWithFilters} />
          </ModalCloseButton>

          <MessageContainer>
            <Image src={CheckSuccessImg} alt="" />
            <MessageTitle>
              {" "}
              {editItem ? "Search Updated!" : "Search Saved!"}
            </MessageTitle>
            <MessageDescription>
              View all saved searches in your Search History
            </MessageDescription>
          </MessageContainer>
        </ModalContent>
      ) : (
        <ModalContent>
          <Title>{editItem ? "Edit Search As" : "Save Search As"}</Title>
          <TextInput
            type="text"
            placeholder="Enter Name"
            value={searchTitle}
            onChange={handleSearchTitle}
          />
          <ModalFooter>
            <StyledButton width={7} onClick={handleClose}>
              Cancel
            </StyledButton>
            <StyledButton
              width={7}
              onClick={handleSearchSaved}
              disabled={!isSaveBtnEnabled}
              style={{
                backgroundColor: isSaveBtnEnabled ? "#333333" : "#ccc",
                cursor: isSaveBtnEnabled ? "pointer" : "not-allowed",
                color: isSaveBtnEnabled ? "#fff" : "#000",
              }}
            >
              {isLoading ? (
                <Loader 
                  height={viewSizeCalculator(1)}
                  width={viewSizeCalculator(1)}
                  isTransparent={true}
                />
              ) : editItem ? (
                "Update"
              ) : (
                "Save"
              )}
            </StyledButton>
          </ModalFooter>
        </ModalContent>
      )}
    </ModalContainer>
  );
};

export default SaveSearchModal;
